import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '32px 32px 0 32px',
    justifyContent: 'space-between'
  },
  headerLogo: {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      width: '100% !important',
      height: '46px'
    }
  },
  body: {
    padding: '32px',
    margin: '0 auto',
    maxWidth: '760px'
  }
});
export default useStyles;